'use client';

import { c as _c } from "react/compiler-runtime";
import { aspCond } from '@module/helpers/conditions/condition';
import { useBoardListQuery } from '@module/queries/customer/customerQueryHooks';
import BaseButton from '@pc/components/atoms/button/BaseButton';
import EventCard from '@pc/components/card/EventCard';
import BasePagenation from '@pc/components/pagenation/BasePagenation';
import NotFoundDisplay from '@pc/components/result/NotFoundDisplay';
import { Input } from '@pc/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@pc/components/ui/select';
import { keepPreviousData } from '@tanstack/react-query';
import { useRouter, useSearchParams } from 'next/navigation';
import type React from 'react';
import { useEffect, useState } from 'react';
type EventType = 'all' | 'now' | 'pre' | 'end';
const eventCardsPerPage = 4;
function EventListContainer() {
  const $ = _c(35);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("page");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const page = Number(t0);
  const [currentPage, setCurrentPage] = useState(1);
  const router = useRouter();
  const currentPageFirstOffset = (currentPage - 1) * eventCardsPerPage;
  const [eventType, setEventType] = useState("all");
  const [searchValue, setSearchValue] = useState("");
  const [searchValueForQuery, setSearchValueForQuery] = useState("");
  let t1;
  if ($[2] !== currentPageFirstOffset || $[3] !== eventType || $[4] !== searchValueForQuery) {
    t1 = {
      page: "event",
      eventType,
      offset: currentPageFirstOffset,
      limit: eventCardsPerPage,
      searchVal: searchValueForQuery
    };
    $[2] = currentPageFirstOffset;
    $[3] = eventType;
    $[4] = searchValueForQuery;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      placeholderData: keepPreviousData
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    data: eventList
  } = useBoardListQuery(t1, t2);
  let t3;
  if ($[7] !== searchValue) {
    t3 = event => {
      event.preventDefault();
      setSearchValueForQuery(searchValue);
      setCurrentPage(1);
    };
    $[7] = searchValue;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const updateQuerySearchValue = t3;
  const isListEmpty = !eventList?.page.total;
  let t4;
  let t5;
  if ($[9] !== page) {
    t4 = () => {
      setCurrentPage(page || 1);
    };
    t5 = [page];
    $[9] = page;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  if ($[12] !== currentPage || $[13] !== router) {
    t6 = () => {
      router.push(`/customer/event?page=${currentPage}`);
    };
    $[12] = currentPage;
    $[13] = router;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== currentPage) {
    t7 = [currentPage];
    $[15] = currentPage;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  useEffect(t6, t7);
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = value => {
      setEventType(value as EventType);
    };
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SelectTrigger className="h-[48px] w-[126px] bg-transparent"><SelectValue placeholder={"\uC804\uCCB4"} /></SelectTrigger>;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Select onValueChange={t8}>{t9}<SelectContent><SelectItem key="all" value="all">{"\uC804\uCCB4"}</SelectItem><SelectItem key="now" value="now">{"\uC9C4\uD589\uC911"}</SelectItem><SelectItem key="pre" value="pre">{"\uC608\uC815"}</SelectItem><SelectItem key="end" value="end">{"\uC885\uB8CC"}</SelectItem></SelectContent></Select>;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = e => setSearchValue(e.currentTarget.value);
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== searchValue) {
    t12 = <Input placeholder={"\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694."} containerClassName="w-[205px]" className="px-[17px]" value={searchValue} onChange={t11} />;
    $[21] = searchValue;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <BaseButton type="submit" variant="primary" size="md" className="ml-2 w-[68px] text-[17px]">{"\uAC80\uC0C9"}</BaseButton>;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t12 || $[25] !== updateQuerySearchValue) {
    t14 = <div className="flex justify-between">{t10}<form className="flex" onSubmit={updateQuerySearchValue}>{t12}{t13}</form></div>;
    $[24] = t12;
    $[25] = updateQuerySearchValue;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== currentPage || $[28] !== eventList?.list || $[29] !== eventList?.page || $[30] !== isListEmpty) {
    t15 = isListEmpty || aspCond.if("asp") ? <NotFoundDisplay className="mt-12" text={"\uAC80\uC0C9\uACB0\uACFC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."} /> : <><div className="mt-12 flex flex-wrap justify-between">{eventList?.list.map(item => <div key={item.idx}><EventCard item={item} currentPage={currentPage} /></div>)}</div><BasePagenation currentPage={currentPage} setCurrentPage={setCurrentPage} pageData={eventList?.page} /></>;
    $[27] = currentPage;
    $[28] = eventList?.list;
    $[29] = eventList?.page;
    $[30] = isListEmpty;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t14 || $[33] !== t15) {
    t16 = <div>{t14}{t15}</div>;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
}
export default EventListContainer;